/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  
// 通用 Module 
const state = {
}
const mutations = {
}
const getters = {
}
const actions = {
  getActive({ rootState }, opt) { // 获取热门活动
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/activity/GetByExhibition?topic=${opt.topic}`, opt.body).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBrandList({ rootState }, opt) { // 获取品牌展商
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/join/GetBrandTopic`, opt, rootState.header).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getQuickEntrance({ rootState }) { // 获取首页快捷入口
    return new Promise((resolve, reject) => {
        axios.get(`${config.api.reqApi}/api/Quick/GetList`).then(res => {
            if (res.data && res.status === 200) {
              resolve(res.data);
            } else {
              resolve(null);
            }
        }).catch((err) => {
            console.log(err);
        });
    });
  },
  getBanner({ rootState }) { // 获取banner
    return new Promise((resolve, reject) => {
        axios.get(`${config.api.reqApi}/api/Banner/all`).then(res => {
            if (res.data && res.status === 200) {
              resolve(res.data);
            } else {
              resolve(null);
            }
        }).catch((err) => {
            console.log(err);
        });
    });
  },
  getNeedsList({ rootState }, opt) { // 获取商机
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/release/GetShortByExhibition`, opt).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBrandChance({ rootState }, opt) { // 获取品牌商机
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/join/GetBrandRelease`, opt, rootState.header).then(data => {
        if (data.data && data.status === 200) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getchanceDetails({ rootState }, id) { // 获取商机详情
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/release?id=${id}`, rootState.header).then(res => {
        if (res.data && res.status === 200) {
          if (res.data.photo.search(/^\[/) !== -1) {
            res.data.photo = JSON.parse(res.data.photo);
          } else {
            res.data.photo = [res.data.photo];
          }
          // res.data.inTime = this.SmartDate(new Date(res.data.inTime));
          resolve(res.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
    },
  
  getGxDetails({ rootState }, id) { // 
      return new Promise((resolve, reject) => {
          axios.get(`${config.api.reqApi}/api/NewRealease?id=${id}`, rootState.header).then(res => {
        if (res.data ) {
          resolve(res.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getGxDetailsNum({ rootState }, id) { // 
      return new Promise((resolve, reject) => {
          axios.get(`${config.api.reqApi}/api/Release?id=${id}`, rootState.header).then(res => {
        if (res.data ) {
          resolve(res.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  getWebKind({ rootState },opt) { // 获取首页分类产品
    return new Promise((resolve, reject) => {
        axios.get(`${config.api.reqApi}/api/Product/HotProduct?top=${opt.top}&productCount=${opt.productCount}`, rootState.header).then(res => {
            if (res.data && res.status === 200) {
              resolve(res.data);
            } else {
              resolve(null);
            }
        }).catch((err) => {
            console.log(err);
        });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 